document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.getElementById('CollectionWrapper');
    if (!wrapper) return;

    const sectionId = wrapper.dataset.sectionId;

    const updateCollection = async (url) => {
        // Adiciona o parâmetro section_id para a Section Rendering API
        const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;

        const productGrid = document.getElementById('ProductGrid');
        if (productGrid) productGrid.style.opacity = '0.5';

        const response = await fetch(fetchUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Substitui o bloco inteiro (Grid + Paginação)
        const newGridWrapper = doc.getElementById('ProductGridWrapper');
        const newProductCount = doc.getElementById('ProductCount');
        if (newGridWrapper) document.getElementById('ProductGridWrapper').innerHTML = newGridWrapper.innerHTML;
        if (newProductCount) document.getElementById('ProductCount').innerHTML = newProductCount.innerHTML;

        window.history.pushState({ path: url }, '', url);

        // RE-BIND: Como destruímos o HTML anterior, precisamos re-anexar os eventos de clique na paginação
        bindPaginationEvents();
    };

    const bindPaginationEvents = () => {
        document.querySelectorAll('.pager a').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                updateCollection(link.getAttribute('href'));
            });
        });
    };

    // Toggle de animação para os selects de filtro (contorna o bug do :focus nativo)
    const bindSelectEvents = () => {
        document.querySelectorAll('.fselect').forEach(select => {
            // Remove os event listeners antigos caso estejamos re-bindando após um fetch
            const newSelect = select.cloneNode(true);
            select.parentNode.replaceChild(newSelect, select);
            
            newSelect.addEventListener('click', () => newSelect.classList.toggle('is-open'));
            newSelect.addEventListener('blur', () => newSelect.classList.remove('is-open'));
            newSelect.addEventListener('change', () => newSelect.classList.remove('is-open'));
        });
    };

    // Filtros — só vincula se o formulário existir (coleções sem filtros não o renderizam)
    const filterForm = document.getElementById('FilterForm');
    if (filterForm) {
        // Usamos delegação de eventos para o form para evitar problemas ao substituir os elementos internos
        filterForm.addEventListener('change', () => {
            const formData = new FormData(filterForm);
            const params = new URLSearchParams(formData);
            updateCollection(`${window.location.pathname}?${params.toString()}`);
        });
    }

    bindPaginationEvents();
    bindSelectEvents();
});